import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type ZendeskConnectorConfig = typeof ZendeskConnector._.Config;

export const ZendeskConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Zendesk,
  logoPath: 'images/zendesk-logo.svg',
  categories: [IntegrationConnectorCategory.Support],
  auths: IntegrationAuth.group([
    IntegrationAuth.oauth2Code({
      name: Integration_Auth_Names_Enum.OauthClient,
      clientId: (config) => config.zendesk.clientId,
      clientSecret: (config) => config.zendesk.clientSecret,
      authorizeUrl: (config) => `https://${config.subdomain}.zendesk.com/oauth/authorizations/new`,
      tokenUrl: (config) => `https://${config.subdomain}.zendesk.com/oauth/tokens`,
      scope: 'read',
      pkce: true,
      extraTokenParams: {
        expires_in: '7200',
      },
      configSchema: z.object({
        subdomain: z.string().min(1),
      }),
      encryptedConfigSchema: z.object({}),
    }),
  ]),
});
